export default __webpack_public_path__ + "static/boulder-1950dfe5e8c4e503123e00d5b9490876.png";